var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSearch = function SvgSearch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2632",
    d: "M6.872 13.696q-2.875 0-4.874-1.991T0 6.848 1.998 1.99Q3.997.001 6.872 0q2.876 0 4.875 1.991 1.998 1.992 1.998 4.857a6.7 6.7 0 0 1-.443 2.41q-.442 1.165-1.162 1.993l3.68 3.713a.6.6 0 0 1 .18.411.56.56 0 0 1-.18.434.6.6 0 0 1-.425.191.6.6 0 0 1-.424-.19l-3.68-3.714q-.9.764-2.069 1.181a7 7 0 0 1-2.35.419m0-1.195q2.388 0 4.03-1.638 1.644-1.637 1.644-4.015t-1.643-4.016q-1.644-1.637-4.03-1.637-2.388 0-4.03 1.637Q1.198 4.47 1.198 6.848t1.643 4.015q1.644 1.638 4.03 1.638"
  })));
};
export default SvgSearch;